module.exports = __webpack_public_path__ + "img/list.7d4d6c3f.svg";